<!-- Post Content -->
<div class="px-4 pb-2">
  <div class="text-[14px] text-gray-800 leading-relaxed font-normal">
    <p class="whitespace-pre-wrap break-words" [innerHTML]="displayContent"></p>

    <!-- Show More/Less Button -->
    <button
      *ngIf="shouldTruncateContent"
      class="text-blue-600 hover:text-blue-800 font-medium text-[13px] mt-1 transition-colors hover:underline focus:outline-none"
      (click)="onToggleContent()"
    >
      {{ showFullContent ? 'Ver menos' : 'Ver más' }}
    </button>
  </div>

  <!-- Post Tags -->
  <div class="mt-2 flex flex-wrap gap-1.5" *ngIf="tags && tags.length > 0">
    <span
      *ngFor="let tag of tags"
      class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium bg-blue-50 text-blue-700 hover:bg-blue-100 transition-colors cursor-pointer border border-blue-100"
    >
      #{{ tag }}
    </span>
  </div>
</div>
